/**
* @desc the ngBookingAddBaggages provides support for collect the information of additional baggages in step 1 of the booking process
* @example <div ng-if="hasAdditionalBaggages" ng-booking-add-baggages request="request" paxinfo="paxinfo" addbaggage="proposal.additionalBaggages" selection="selection"></div>
*/

webClient.directive('ngBookingAdditionalBaggages', ['$window', '$timeout', '$i18next', 'templateService', 'trackingService', 'gtmModel', 'gtmProduct',
    function ($window, $timeout, $i18next, templateService, trackingService, gtmModel, gtmProduct) {
        var directive = {};
        directive.restrict = 'EA';
        directive.scope = {
            request: "=",
            paxinfo: "=",
            itineraries: "=",
            proposal: "=",
            triptype: "=",
            istrainonly: "=",
            iskiwi: "="
        };
        directive.link = function ($scope, $element) {

            templateService.compile($scope, $element, 'tpl/_BookingAdditionalBaggages.html');
            $scope.getUrl = $window.getUrl;
            $scope.getTemplateUrl = $window.getTemplateUrl;
            $scope.siteType = $window.site.type;
            var adultCount = 0;
            var childCount = 0;
            var infantCount = 0;
            $scope.totalPrice = 0;
            $scope.nbSyncPassagerAdded = 0;
            $scope.nbSyncItinariesAdded = 0;
            $scope.showLuggageSpecialRuleSyncPassager = false;
            $scope.showLuggageSpecialRuleSyncItinaries = false;
            $scope.hideSparePhrase = false;
            $scope.luggageSpecialRuleSyncItinariesCarrierName = "";
            $scope.luggageSpecialRuleSyncPassagerCarrierName = "";
            $scope.displaySelectionSuccess = false;
            $scope.travelHasInfant = $scope.paxinfo && $scope.paxinfo.some(pax => pax.paxType == "2");
            $scope.currencyManagerEnabled = typeof (CurrencyManager) !== "undefined" && CurrencyManager.isEnabled() === true;
            $scope.noLuggageChecked = CurrencyManager.getPriceItemSpecificBaggage($i18next.t("airbooking.baggage.nochecked").replace('{0}', 0).replace('{1}', '€'));
            $scope.noLuggageCabin = CurrencyManager.getPriceItemSpecificBaggage($i18next.t("airbooking.baggage.nocabin").replace('{0}', 0).replace('{1}', '€'));
            $scope.getMessageSyncBaggage = function () {
                const showItin = $scope.showLuggageSpecialRuleSyncItinaries;
                const showPax = $scope.showLuggageSpecialRuleSyncPassager;
                const itinAirline = $scope.luggageSpecialRuleSyncItinariesCarrierName;
                const paxAirline = $scope.luggageSpecialRuleSyncPassagerCarrierName;

                // Cas 1 : itinéraires + passagers + même compagnie
                if (showItin && showPax && itinAirline === paxAirline) {
                    return $i18next.t("airbooking.baggage.samechoiceallitineraryandpassenger", { airline: itinAirline });
                }

                // Cas 2 : itinéraires et/ou passagers mais compagnies différentes
                let messages = [];
                if (showItin) {
                    messages.push($i18next.t("airbooking.baggage.samechoiceallitinerary", { airline: itinAirline }));
                }
                if (showPax) {
                    messages.push($i18next.t("airbooking.baggage.samechoiceallpassengers", { airline: paxAirline }));
                }

                return messages.join("\n");
            }
            $scope.getMessageSyncToast = function () {
                if ($scope.showLuggageSpecialRuleSyncItinaries && $scope.showLuggageSpecialRuleSyncPassager) {
                    return $i18next.t("airbooking.baggage.choiceapplicationall");
                } else if ($scope.showLuggageSpecialRuleSyncItinaries) {
                    return $i18next.t("airbooking.baggage.choiceapplicationitinerary");
                } else if ($scope.showLuggageSpecialRuleSyncPassager) {
                    return $i18next.t("airbooking.baggage.choiceapplicationpassengers");
                }
            }

            $scope.showToast = function () {
                if ($scope.showLuggageSpecialRuleSyncItinaries || $scope.showLuggageSpecialRuleSyncPassager) {
                    document.querySelector('#i-smooth-infos-bags .slide-in-fade-out').classList.toggle('show');
                    document.getElementById('i-smooth-infos-bags').classList.toggle('hide');
                }

            }

            $scope.isServair = window.isServair;

            $scope.segmentsCabinLuggage = [];
            $scope.listIATABaggagesSyncAllPassengerAllItineraries = ['FR', 'OE'];
            $scope.listIATABaggagesSyncAllItineraries = ['U2'];
            $scope.counter = 0;
            $scope.drawerLuggageOpened = false;

            const PaxType = Object.freeze({
                ADULT: 0,
                CHILD: 1,
                BABY: 2
            });

            const BaggagePolicy = Object.freeze({
                PIECE: 0,
                WEIGHT: 2
            })

            const BaggageLocation = Object.freeze({
                HOLD: 0,
                CABIN: 1
            });

            $scope.toggleDrawerLuggage = function () {
                $scope.drawerLuggageOpened = !$scope.drawerLuggageOpened;
            };

            function updatePrice() {
                $scope.totalPrice = 0;
                $scope.paxinfo.each(function (pax) {
                    for (var it in pax.baggageByItinerary) {
                        for (var location in pax.baggageByItinerary[it]) {
                            if (pax.baggageByItinerary[it][location].quantity > 0)
                                $scope.totalPrice += pax.baggageByItinerary[it][location].totalPrice.value;
                        }
                    }
                });

                //Tracking
                try {
                    //GTM
                    if (trackingService.isActivated()) {
                        trackingService.removeProduct('BAGGAGE');//we must have only one baggage product !
                        if ($scope.totalPrice > 0) {
                            trackingService.addProduct(gtmProduct.parseBaggage($scope.totalPrice));
                        } 
                    }
                }
                catch (ex) {
                    console.log(ex.message);
                    $window.trackingError = ex.message;
                }
            }




            $scope.setHideSparePhrase = function (value) {
                $scope.hideSparePhrase = value;
                console.log('hideSparePhrase: ' + $scope.hideSparePhrase);
            };

            $scope.canAddBaggage = false;

            $scope.itineraries.each(function (it, index) {
                if (it.additionalBaggages && it.additionalBaggages.length > 0) {
                    $scope.canAddBaggage = true;
                }
                it.segments.each(function (itSegment) {

                    //Segment with Cabin luggage to pay
                    if (itSegment.airline.iata.toLowerCase() === "fr" && moment(itSegment.departureDateTime, "YYYY-MM-DD").isAfter('2018-11-01', 'day')) {
                        $scope.segmentsCabinLuggage.push({
                            airlineIata: itSegment.airline.iata,
                            airlineName: itSegment.airline.name
                        });
                    }
                });
            });

            $scope.warnSegmentCabinLuggage = $scope.segmentsCabinLuggage.any();

            function formatDimensions(dimensions) {
                if (!dimensions) return '';
                const dimText = [dimensions.length, dimensions.width, dimensions.height]
                    .map(Number)
                    .sort((a, b) => b - a)
                    .join(' x ');
                return dimText + ` ${dimensions.unit}`
            }

            //Dictionary [itineraryKey+PaxType]
            $scope.includeBaggagesbyItinerary = {};

            var nbFaresWithIncludedLuggage = 0;
            var nbFares = 0;
            $scope.hideServairLuggageMessage = false;

            $scope.$watch('proposal', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    console.log('proposal a changé !', newVal);
                    updateBaggages();
                }
            });

            function updateBaggages() {
                $scope.proposal.fares.each(function (f) {
                    f.itineraries.each(function (fareItinerary, index) {
                        let baggageItinerary = {
                            itineraryKey: fareItinerary.key,
                            baggageQuantity: fareItinerary.baggageQuantity,
                            baggageWeight: fareItinerary.baggageWeight,
                            paxType: f.paxType
                        };
                        if (fareItinerary.baggages) {
                            fareItinerary.baggages.each(baggage => {
                                if (baggage.location == BaggageLocation.HOLD) {
                                    baggageItinerary.hold = baggage;
                                    if (baggage.policy == BaggagePolicy.WEIGHT) {
                                        baggage.quantity = 1;
                                        baggageItinerary.hold.text = $i18next.t('airbooking.baggage.checkedweightincluded', { weight: baggage.weight, count: baggage.quantity });
                                    } else if (baggage.policy == BaggagePolicy.PIECE && baggage.quantity > 0) {
                                        baggageItinerary.hold.text = $i18next.t('airbooking.baggage.checkedincluded', { count: baggage.quantity });
                                        const weightText = baggage.weight > 0 ? `${baggage.quantity} x ${baggage.weight} kg` : "";
                                        baggageItinerary.hold.text += weightText ? ` (${weightText})` : "";
                                    } else {
                                        baggageItinerary.hold.quantity = 0;
                                        let holdText = $i18next.t('airbooking.baggage.nocheckedincluded');
                                        if (f.paxType != 2 && (!$scope.itineraries[index].additionalBaggages || $scope.itineraries[index].additionalBaggages.length == 0)) {
                                            holdText += ' - ' + $i18next.t('airbooking.baggage.addairportonly');
                                        }
                                        baggageItinerary.hold.text = holdText;
                                    }
                                } else if (baggage.location == BaggageLocation.CABIN) {
                                    baggageItinerary.cabin = baggage;
                                    if (baggage.quantity > 0 && f.paxType != PaxType.BABY) {
                                        const weightText = baggage.weight > 0 ? `${baggage.quantity} x ${baggage.weight} kg` : '';
                                        const dimText = formatDimensions(baggage.dimensions);
                                        const totalText = [weightText, dimText].filter(Boolean);

                                        baggageItinerary.cabin.text = $i18next.t('airbooking.baggage.cabinincluded', { count: baggage.quantity });
                                        if (totalText.length > 0) {
                                            baggageItinerary.cabin.text += ` (${totalText.join(" - ")})`
                                        }
                                    } else if (f.paxType != PaxType.BABY) {
                                        baggageItinerary.cabin.text = $i18next.t('airbooking.baggage.nocabinincluded');
                                    } else {
                                        baggageItinerary.cabin.text = $i18next.t('airbooking.baggage.unavailableinfo');
                                    }
                                }
                            });
                        }
                        if (!baggageItinerary.hold) {
                            let text = $i18next.t('airbooking.baggage.nocheckedincluded');
                            if (f.paxType != 2 && (!$scope.itineraries[index].additionalBaggages || $scope.itineraries[index].additionalBaggages.length == 0)) {
                                text += ' - ' + $i18next.t('airbooking.baggage.addairportonly');
                            }
                            baggageItinerary.hold = {
                                text: text,
                                quantity: 0
                            }
                        }
                        if (!baggageItinerary.cabin) {
                            baggageItinerary.cabin = {
                                text: $i18next.t('airbooking.baggage.unavailableinfo'),
                                quantity: 0
                            }
                        }
                        $scope.includeBaggagesbyItinerary[fareItinerary.key + f.paxType] = baggageItinerary;


                        if ($scope.includeBaggagesbyItinerary[fareItinerary.key + f.paxType].baggageQuantity > 0) {
                            nbFaresWithIncludedLuggage++;
                        }
                        nbFares++;
                    })
                })
            }
            updateBaggages();

            if (nbFaresWithIncludedLuggage == nbFares) {
                $scope.hideSparePhrase = true;
                $scope.hideServairLuggageMessage = true;
            }

            //call because needed on page reload
            updatePrice();

            //Prepare passenger data
            $scope.bagPaxInfo = $scope.paxinfo.map(function (pax) {
                var text = null;
                /// Gérer l'affichage des intitulés des voyageurs dans la partie DP
                if (pax.hasOwnProperty('paxTypeHotel')) {
                    if (pax.paxTypeHotel == "ADT" || pax.specificAge >= 12)
                        text = $i18next.t("airbooking.luggage.adult") + " " + (++adultCount);

                    if (pax.paxTypeHotel == "CHD" && pax.specificAge < 12)
                        text = $i18next.t("airbooking.luggage.child") + " " + (++childCount);

                    if (pax.paxTypeHotel == "INF")
                        text = $i18next.t("airbooking.luggage.infant") + " " + (++infantCount);

                }
                else {

                    if (pax.paxType == "0")
                        text = $i18next.t("airbooking.luggage.adult") + " " + (++adultCount);

                    if (pax.paxType == "1")
                        text = $i18next.t("airbooking.luggage.child") + " " + (++childCount);

                    if (pax.paxType == "2")
                        text = $i18next.t("airbooking.luggage.infant") + " " + (++infantCount);
                }

                if (!pax.baggageByItinerary)
                    pax.baggageByItinerary = {};

                return { text: text, inner: pax };
            });

            //Get Culture text's
            $scope.getText = function (key) {
                return window.culture.texts[key];
            };

            function checkLuggageWithSpecialRules() {

                var counterSyncItinaries = 0;
                var counterSyncPassengers = 0;

                $scope.itineraries.each(function (it) {
                    if ($scope.listIATABaggagesSyncAllPassengerAllItineraries.includes(it.marketingCarrier.iata)) {
                        $scope.bagPaxInfo.each(function (paxitem) {
                            counterSyncPassengers++;
                            $scope.luggageSpecialRuleSyncPassagerCarrierName = it.marketingCarrier.name;
                        });
                    }

                    if ($scope.listIATABaggagesSyncAllItineraries.includes(it.marketingCarrier.iata)) {
                        $scope.bagPaxInfo.each(function (paxitem) {
                            counterSyncItinaries++;
                            $scope.luggageSpecialRuleSyncItinariesCarrierName = it.marketingCarrier.name;
                        });
                    }

                });

                $scope.showLuggageSpecialRuleSyncItinaries = counterSyncItinaries > 1;
                $scope.showLuggageSpecialRuleSyncPassager = counterSyncPassengers > 1;
            }

            checkLuggageWithSpecialRules();

            //Fpop
            $scope.FPop = function (textField, popDiv, style) {
                var target = $("#" + textField).get(0);
                $window.FPop({ oTarget: target, iPop: popDiv, vStyle: style, disabledOkStyle: !$scope.displaySelectionSuccess });
            };

            //FSelect
            $scope.FSelect = function (name, target, _event) {
                var obj = $("#" + name + "-pop").find("ul").get(0);
                if (target)
                    $window.FSelect({ e: { target: target }, myObj: obj, vName: name, ignoreFlagsReplace: true, disabledOkStyle: !$scope.displaySelectionSuccess });
                else
                    $window.FSelect({ e: _event, myObj: obj, vName: name, ignoreFlagsReplace: true, disabledOkStyle: !$scope.displaySelectionSuccess });
            };



            //Update additionals baggages price
            $scope.updatePrice = function () {
                updatePrice();

                var holdByItinerary = {};
                var cabinByItinerary = {};

                function addToGroup(dict, itKey, bag) {
                    if (!dict[itKey]) dict[itKey] = [];
                    var groupKey = String(bag.weight) + '_' + (bag.dimensions ? JSON.stringify(bag.dimensions) : 'nodim');
                    var group = dict[itKey].find(function (g) { return g.groupKey === groupKey; });
                    if (group) {
                        group.totalQuantity += bag.quantity;
                    } else {
                        dict[itKey].push({
                            groupKey: groupKey,
                            weight: bag.weight,
                            dimensions: bag.dimensions || null,
                            totalQuantity: bag.quantity
                        });
                    }
                }

                $scope.paxinfo.each(function (pax) {
                    if (pax.baggageByItinerary) {
                        for (var itKey in pax.baggageByItinerary) {
                            var byIt = pax.baggageByItinerary[itKey];
                            if (byIt[0] && byIt[0].quantity > 0)
                                addToGroup(holdByItinerary, itKey, byIt[0]);
                            if (byIt[1] && byIt[1].quantity > 0)
                                addToGroup(cabinByItinerary, itKey, byIt[1]);
                        }
                    }
                });

                $scope.$emit("addBaggagesChanged", { holdByItinerary: holdByItinerary, cabinByItinerary: cabinByItinerary });
            };

            var innerBaggageSelected = function (pax, bag, itKey) {
                //delete pax.inner.baggageByItinerary[itKey];
                
                if (typeof (CurrencyManager) !== "undefined" && CurrencyManager.isEnabled() === true) {
                    bag.description = CurrencyManager.getPriceItemSpecificBaggage(bag.description);
                    setTimeout(function () {
                        CurrencyManager.updatePriceItemsSpecificBaggages();
                    }, 500);
                }
                if (!pax.inner.baggageByItinerary[itKey]) {
                    pax.inner.baggageByItinerary[itKey] = {};
                }
                pax.inner.baggageByItinerary[itKey][bag.location] = bag


                console.log("innerBaggageSelected")
                console.log("pax")
                console.log(pax)
                console.log("bag")
                console.log(bag)
                console.log("itKey")
                console.log(itKey)

                if (bag.key) {
                    $scope.$emit("addAdditionalBaggage", { pax: pax, bag: bag, itKey: itKey });
                } else {
                    $scope.$emit("removeAdditionalBaggage", { pax: pax, bag: bag, itKey: itKey });
                }
            };


            //Select a baggage
            $scope.selectBaggage = function (pax, bag, itineraryKey, location) {
                //innerBaggageSelected(pax, bag, itineraryKey);
                $scope.displaySelectionSuccess = false;
                var itinaryObject = $scope.itineraries.find(function (el) { return el.key === itineraryKey });

                if (itinaryObject) {
                    const itineraryLabel = itinaryObject.origin.cityIata + " - " + itinaryObject.destination.cityIata;
                    bag.itineraryLabel = itineraryLabel;

                    //a t-on des regles particulieres à appliquer sur ce segment? 
                    if ($scope.listIATABaggagesSyncAllPassengerAllItineraries.includes(itinaryObject.marketingCarrier.iata) || $scope.listIATABaggagesSyncAllItineraries.includes(itinaryObject.marketingCarrier.iata)) {

                        $scope.itineraries.each(function (it) {
                            if (it.additionalBaggages && it.additionalBaggages.length > 0) {
                                var selectedBagUniqueKey = location + String(bag.weight) + String(bag.quantity);

                                var selectedBag = it.additionalBaggages.find(function (el) { return String(el.location) + String(el.weight) + String(el.quantity) === selectedBagUniqueKey });
                                if (location == 0) {
                                    selectedBag = it.holdAdditionalBaggages.find(function (el) { return String(el.location) + String(el.weight) + String(el.quantity) === selectedBagUniqueKey });
                                } else if (location == 1) {
                                    selectedBag = it.cabinAdditionalBaggages.find(function (el) { return String(el.location) + String(el.weight) + String(el.quantity) === selectedBagUniqueKey });
                                }

                                if (selectedBag) {

                                    var itiCurrent = it.marketingCarrier.iata;
                                    selectedBag.itineraryLabel = itineraryLabel;

                                    if (itiCurrent == "OE") {
                                        itiCurrent = "FR";
                                    }

                                    var itiSelected = itinaryObject.marketingCarrier.iata;

                                    if (itiSelected == "OE") {
                                        itiSelected = "FR";
                                    }


                                    if ($scope.listIATABaggagesSyncAllPassengerAllItineraries.includes(it.marketingCarrier.iata) && itiCurrent === itiSelected) {

                                        $scope.bagPaxInfo.each(function (paxitem) {
                                            if (paxitem.inner.paxType != 2) {
                                                innerBaggageSelected(paxitem, selectedBag, it.key);
                                                $scope.displaySelectionSuccess = true;
                                            }

                                        });
                                    }
                                    else if ($scope.listIATABaggagesSyncAllItineraries.includes(it.marketingCarrier.iata) && itiCurrent === itiSelected) {
                                        innerBaggageSelected(pax, selectedBag, it.key);
                                        $scope.displaySelectionSuccess = true
                                    }
                                }
                            }

                        });
                    }
                    else {
                        innerBaggageSelected(pax, bag, itineraryKey);
                    }


                    $scope.updatePrice();
                    checkLuggageWithSpecialRules();
                }

            };


            $scope.onAddBaggage = function (pax, bag, itineraryKey, location) {
                $scope.selectBaggage(pax, bag, itineraryKey, location);
                //Tracking
                try {
                    //GTM
                    if (trackingService.isActivated()) {
                        if (trackingService.interactionEvent) {
                            trackingService.interactionEvent("add_baggage", null, null, { totalPrice: $scope.totalPrice });
                        }
                    }
                }
                catch (ex) {
                    console.log(ex.message);
                    $window.trackingError = ex.message;
                }
            }

            //Reset baggages to cero
            $scope.$on("onNoAddBaggagesSelection", function (event, args) {
                var paxIndex = 0;
                $scope.bagPaxInfo.each(function (pax) {
                    var itineraryIndex = 0;
                    $scope.itineraries.each(function (it) {
                        [0, 1].forEach(function (loc) {
                            var auxNoBaggage = {
                                key: null,
                                quantity: 0,
                                totalPrice: { value: 0 },
                                weight: 0,
                                location: loc,
                                description: ($i18next.t('airbooking.aucunbagage') + '').format('0', '€'),
                                bf: true
                            };
                            $scope.selectBaggage(pax, auxNoBaggage, it.key, loc);
                        });

                        // Reset FSelect visual state after Angular digest
                        (function (pi, ii) {
                            $timeout(function () {
                                var holdName = 'pax-' + pi + '-i-flight-' + ii + '-hold';
                                var holdFirstLi = $('#' + holdName + '-pop ul li:first').get(0);
                                if (holdFirstLi) $scope.FSelect(holdName, holdFirstLi, null);

                                var cabinName = 'pax-' + pi + '-i-flight-' + ii + '-cabin';
                                var cabinFirstLi = $('#' + cabinName + '-pop ul li:first').get(0);
                                if (cabinFirstLi) $scope.FSelect(cabinName, cabinFirstLi, null);
                            }, 0);
                        })(paxIndex, itineraryIndex);

                        itineraryIndex++;
                    });
                    paxIndex++;
                });
            });



        };
        return directive;
    }]);